import { NextPage } from 'next'
import { InvitationSignUp } from '~/components/self-service-sign-up/InvitationSignUp'
import { SelfServiceSignUp } from '~/components/self-service-sign-up/SelfServiceSignUp'
import { useInvitation } from '~/hooks/use-invitation'

export const SignUp: NextPage = () => {
  const invitation = useInvitation()

  return invitation ? <InvitationSignUp invitation={invitation} /> : <SelfServiceSignUp />
}

export default SignUp
